import React, { useState, useEffect, useRef } from 'react';
import { submitForm } from '../utils/formSubmit';
import Swal from 'sweetalert2';
import './CaFreeAssessment.css';

// Embedded inline SVG US Flag
const CaFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 450"
    style={{ borderRadius: '2px', display: 'inline-block', verticalAlign: 'middle', width: '22px', height: '14px', flexShrink: 0 }}
  >
    <rect width="900" height="450" fill="#fff" />
    <rect width="225" height="450" fill="#D80621" /><rect x="675" width="225" height="450" fill="#D80621" /><polygon fill="#D80621" points="450,75 420,165 330,165 400,215 375,305 450,255 525,305 500,215 570,165 480,165" />


  </svg>
);

const countryList = [
  { name: 'United States', code: '+1', iso: 'us' }
];

const CaFreeAssessment = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    course: 'Noorani Qaida',
    phone: '',
    message: ''
  });

  const [selectedCountry, setSelectedCountry] = useState(countryList[0]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const countryDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (countryDropdownRef.current && !countryDropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await submitForm('Free Registration Assessment Form', {
        fullName: `${formData.firstName} ${formData.lastName}`.trim(),
        email: 'Not Provided (Free Registration Form)',
        phone: `${selectedCountry.code} ${formData.phone}`,
        course: formData.course,
        message: formData.message
      });

      Swal.fire({
        title: 'Registration Submitted!',
        text: `Thank you, ${formData.firstName}! Our tutors will evaluate your level and contact you shortly.`,
        icon: 'success',
        confirmButtonColor: '#006100'
      });

      setFormData({
        firstName: '',
        lastName: '',
        course: 'Noorani Qaida',
        phone: '',
        message: ''
      });
      window.location.href = '/thank-you-enrollment-successful/';
    } catch (error) {
      Swal.fire({
        title: 'Error!',
        text: 'Failed to submit registration. Please try again.',
        icon: 'error',
        confirmButtonColor: '#006100'
      });
    } finally {
      setSubmitting(false);
    }
  };

  const filteredCountries = countryList.filter(
    (c) =>
      c.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      c.code.includes(searchQuery)
  );

  return (
    <section className="Ca-assessment-section" id="free-assessment">
      <div className="Ca-assessment-section__container">
        {/* Left Column: Text & Content */}
        <div className="Ca-assessment-section__left">
          <div className="Ca-assessment-section__badge">
            <svg className="Ca-assessment-section__badge-icon" viewBox="0 0 640 512" width="20" height="20" fill="#006100">
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
            </svg>
            <span>Apply For Free Registration</span>
          </div>

          <h2 className="Ca-assessment-section__title">
            Not Sure Which Course Is Right? Our Tutors Will Assess Your Current Level For Free!
          </h2>

          <p className="Ca-assessment-section__desc">
            Our experienced tutors evaluate your Quran reading and understanding level through a simple, no-pressure assessment. Based on this, we recommend the most suitable course to ensure steady progress and confident learning.
          </p>

          <ul className="Ca-assessment-section__list">
            <li className="Ca-assessment-section__list-item">
              <span className="Ca-assessment-section__check">✔</span>
              Experienced Tutors
            </li>
            <li className="Ca-assessment-section__list-item">
              <span className="Ca-assessment-section__check">✔</span>
              Flexible Hours
            </li>
          </ul>

          <div className="Ca-assessment-section__contacts">
            <a href="tel:+16477385707" className="Ca-assessment-section__contact-item">
              <div className="Ca-assessment-section__contact-icon">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27 11.72 11.72 0 003.7.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.7 1 1 0 01-.27 1.11z" />
                </svg>
              </div>
              <div className="Ca-assessment-section__contact-text">
                <span className="Ca-assessment-section__contact-label">Call Us Anytime</span>
                <span className="Ca-assessment-section__contact-val">647-738-5707</span>
              </div>
            </a>

            <a href="mailto:info@alquranlesson.com" className="Ca-assessment-section__contact-item">
              <div className="Ca-assessment-section__contact-icon">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                </svg>
              </div>
              <div className="Ca-assessment-section__contact-text">
                <span className="Ca-assessment-section__contact-label">Email Us Anytime</span>
                <span className="Ca-assessment-section__contact-val">info@alquranlesson.com</span>
              </div>
            </a>
          </div>
        </div>

        {/* Right Column: Topographic Form Card */}
        <div className="Ca-assessment-section__right">
          <div className="Ca-assessment-card">
            <form onSubmit={handleSubmit} className="Ca-assessment-form">
              {/* First Name & Last Name Row */}
              <div className="Ca-assessment-form-row">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  className="Ca-assessment-input"
                />
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  className="Ca-assessment-input"
                />
              </div>

              {/* Course Select Dropdown matching screenshot options */}
              <div className="Ca-assessment-form-group">
                <select
                  name="course"
                  value={formData.course}
                  onChange={handleChange}
                  required
                  className="Ca-assessment-select"
                >
                  <option value="Noorani Qaida">Noorani Qaida</option>
                  <option value="Quran Tajweed Classes">Quran Tajweed Classes</option>
                  <option value="Quran Reading Classes">Quran Reading Classes</option>
                  <option value="Quran Memorization Classes">Quran Memorization Classes</option>
                  <option value="Quran Translation Classes">Quran Translation Classes</option>
                </select>
              </div>

              {/* Phone Input with US Flag Dropdown */}
              <div className="Ca-assessment-form-group" ref={countryDropdownRef} style={{ position: 'relative' }}>
                <div className="Ca-assessment-phone-box">
                  <button
                    type="button"
                    className="Ca-assessment-country-btn"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <CaFlag />
                    <span className="Ca-assessment-arrow">▲</span>
                    <span className="Ca-assessment-code">{selectedCountry.code}</span>
                  </button>
                  <span className="Ca-assessment-divider">|</span>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="Ca-assessment-phone-input"
                  />
                </div>

                {/* Country Code Dropdown */}
                {isDropdownOpen && (
                  <div className="Ca-assessment-country-dropdown">
                    <div className="Ca-assessment-search-wrapper">
                      <input
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="Ca-assessment-search-input"
                        autoFocus
                      />
                    </div>
                    <ul className="Ca-assessment-country-menu">
                      {filteredCountries.map((c) => (
                        <li
                          key={c.name}
                          className={`Ca-assessment-country-option ${c.name === selectedCountry.name ? 'Ca-assessment-country-option--active' : ''}`}
                          onClick={() => {
                            setSelectedCountry(c);
                            setIsDropdownOpen(false);
                            setSearchQuery('');
                          }}
                        >
                          <span className="Ca-assessment-opt-flag">
                            <CaFlag />
                          </span>
                          <span className="Ca-assessment-opt-name">{c.name}</span>
                          <span className="Ca-assessment-opt-code">{c.code}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Message Field */}
              <div className="Ca-assessment-form-group">
                <input
                  type="text"
                  name="message"
                  placeholder="Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="Ca-assessment-input"
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={submitting}
                className="Ca-assessment-submit-btn"
              >
                {submitting ? 'Booking Trial...' : 'Book My Free Trial'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaFreeAssessment;
